import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const BankDetailsSection = ({ formData, handleChange }) => {
    return (
        <Box>
            <Typography variant="h6" className="mb-3">Bank Details</Typography>

            <div className="row gx-2">
                <div className="col-md-4">
                    <TextField
                        className="w-100"
                        label="Account Number"
                        name="accountNumber"
                        value={formData.accountNumber}
                        onChange={handleChange}
                        margin="dense"
                    />
                </div>
                <div className="col-md-4">
                    <TextField
                        className="w-100"
                        label="IFSC Code"
                        name="ifsc"
                        value={formData.ifsc}
                        onChange={handleChange}
                        margin="dense"
                    />
                </div>
                <div className="col-md-4">
                    <TextField
                        className="w-100"
                        label="Branch"
                        name="branch"
                        value={formData.branch}
                        onChange={handleChange}
                        margin="dense"
                    />
                </div>
            </div>

            <div className="row gx-2">
                <div className="col-md-4">
                    <TextField
                        className="w-100"
                        label="Bank Name"
                        name="bank"
                        value={formData.bank}
                        onChange={handleChange}
                        margin="dense"
                    />
                </div>
                <div className="col-md-4">
                    <TextField
                        className="w-100"
                        label="Account Holder Name"
                        name="accountHolderName"
                        value={formData.accountHolderName}
                        onChange={handleChange}
                        margin="dense"
                    />
                </div>
            </div>
        </Box>
    );
};

export default BankDetailsSection;
